import { useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhatIsTOR1 } from './components/WhatIsTOR1';
import { AboutUs } from './components/AboutUs';
import { Services } from './components/Services';
import { HowItWorks } from './components/HowItWorks';
import { MovingFromSpain } from './components/MovingFromSpain';
import { PricingSection } from './components/PricingSection';
import { RelocationRoutes } from './components/RelocationRoutes';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsConditions } from './components/TermsConditions';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsConditions, setShowTermsConditions] = useState(false);

  if (showPrivacyPolicy) {
    return (
      <>
        <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />
        <Toaster />
      </>
    );
  }

  if (showTermsConditions) {
    return (
      <>
        <TermsConditions onClose={() => setShowTermsConditions(false)} />
        <Toaster />
      </>
    );
  }

  return (
    <div className="App">
      <Header />
      <Hero />
      <WhatIsTOR1 />
      <AboutUs />
      <Services />
      <HowItWorks />
      <MovingFromSpain />
      <PricingSection />
      <RelocationRoutes />
      <Benefits />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer 
        onPrivacyClick={() => setShowPrivacyPolicy(true)}
        onTermsClick={() => setShowTermsConditions(true)}
      />
      <Toaster />
    </div>
  );
}

export default App;
